export default __webpack_public_path__ + "static/media/logo_text.738b7e06.png";